import { render, staticRenderFns } from "./DecomptesIJ.vue?vue&type=template&id=4b0ab712&scoped=true"
import script from "./DecomptesIJ.vue?vue&type=script&lang=js"
export * from "./DecomptesIJ.vue?vue&type=script&lang=js"
import style0 from "./DecomptesIJ.vue?vue&type=style&index=0&id=4b0ab712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ab712",
  null
  
)

export default component.exports